/**
 * Analytics utility for tracking user events and behaviors
 */

/**
 * Track an event with optional properties
 * @param {string} eventName - Name of the event to track
 * @param {Object} properties - Additional properties to include with the event
 */
export const trackEvent = (eventName, properties = {}) => {
  try {
    // Check for analytics library
    if (window.analytics && typeof window.analytics.track === 'function') {
      window.analytics.track(eventName, properties);
    }
    
    // Fallback logging if needed
    if (process.env.NODE_ENV === 'development') {
      console.log('[Analytics]', eventName, properties);
    }
  } catch (error) {
    console.error('[Analytics Error]', error);
  }
};

/**
 * Identify a user with optional traits
 * @param {string} userId - User ID to identify
 * @param {Object} traits - User traits to record
 */
export const identifyUser = (userId, traits = {}) => {
  try {
    // Check for analytics library
    if (window.analytics && typeof window.analytics.identify === 'function') {
      window.analytics.identify(userId, traits);
    }
  } catch (error) {
    console.error('[Analytics Error]', error);
  }
};

/**
 * Track page view
 * @param {string} pageName - Name of the page
 * @param {Object} properties - Additional properties
 */
export const trackPageView = (pageName, properties = {}) => {
  try {
    // Check for analytics library
    if (window.analytics && typeof window.analytics.page === 'function') {
      window.analytics.page(pageName, properties);
    }
    
    // Fallback logging if needed
    if (process.env.NODE_ENV === 'development') {
      console.log('[Page View]', pageName, properties);
    }
  } catch (error) {
    console.error('[Analytics Error]', error);
  }
};

/**
 * Initialize analytics with configuration
 * @param {Object} config - Configuration options
 */
export const initAnalytics = (config = {}) => {
  try {
    // For future implementation
    console.log('[Analytics] Initialized with config:', config);
  } catch (error) {
    console.error('[Analytics Error]', error);
  }
};

export default {
  trackEvent,
  identifyUser,
  trackPageView,
  initAnalytics
};